const VIEWPORT_MARGIN = 8;
const TRIGGER_GAP = 4;

export function nextFilterPanelPosition({
  triggerRect,
  panelWidth,
  panelHeight,
  viewportWidth,
  viewportHeight,
  align,
  previousShiftUp,
}: {
  triggerRect: Pick<DOMRect, "left" | "right" | "bottom">;
  panelWidth: number;
  panelHeight: number;
  viewportWidth: number;
  viewportHeight: number;
  align: "start" | "end";
  previousShiftUp: number;
}): { top: number; left: number; shiftUp: number } {
  let left =
    align === "start" ? triggerRect.left : triggerRect.right - panelWidth;
  left = Math.max(
    VIEWPORT_MARGIN,
    Math.min(left, viewportWidth - panelWidth - VIEWPORT_MARGIN),
  );

  const preferredTop = triggerRect.bottom + TRIGGER_GAP;
  let shiftUp = previousShiftUp;
  if (panelHeight > 0) {
    const overflow =
      preferredTop + panelHeight + VIEWPORT_MARGIN - viewportHeight;
    if (overflow > shiftUp) {
      shiftUp = overflow;
    }
  }

  const top = Math.max(VIEWPORT_MARGIN, preferredTop - shiftUp);
  return { top, left, shiftUp: preferredTop - top };
}
